import { render, staticRenderFns } from "./ListingDetailsLivestock.vue?vue&type=template&id=6181031d&scoped=true"
import script from "./ListingDetailsLivestock.vue?vue&type=script&lang=js"
export * from "./ListingDetailsLivestock.vue?vue&type=script&lang=js"
import style0 from "./ListingDetailsLivestock.vue?vue&type=style&index=0&id=6181031d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6181031d",
  null
  
)

export default component.exports